import { FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from "@angular/forms";
import { InputErrorClass } from "../../../../shared/component/input/input-component/input.component";
import { LocalDate } from "../../../../../core/pojo/date-variable";
import { YYYY_MM_DD } from "../../../../../util/common/date-service/date.service";

export const NEW_PERIOD_IS_EQUAL_TO_INITIAL_PERIOD = 'newPeriodIsEqualToInitialPeriod';
export const NEW_PERIOD_IS_NOT_PROVIDED = 'newPeriodIsNotProvided';

export interface NewPeriodInputWrapper {
  additionalClass: InputErrorClass;
  bottomText: string;
}

export class ModalCopyPeriodFormService {
  form: FormGroup<{
    initialPeriod: FormControl<LocalDate>,
    newPeriod: FormControl<Date>,
  }>;

  constructor(initialPeriod: LocalDate) {
    this.form = new FormGroup({
      initialPeriod: new FormControl<LocalDate>(initialPeriod, { validators: [Validators.required] }),
      newPeriod: new FormControl<Date>(null, { validators: [Validators.required, Validators.maxLength(YYYY_MM_DD.length)] }),
    }, { validators: [ this.createModalCopyPeriodValidator() ] });
  }

  private createModalCopyPeriodValidator(): ValidatorFn {
    return (form: FormGroup): ValidationErrors => {
      const initialPeriod = form.controls.initialPeriod.getRawValue();
      const newPeriod = form.controls.newPeriod.getRawValue();

      if (!initialPeriod) {
        return { initialPeriodIsNotProvided: true };
      }
      if (!newPeriod) {
        return { newPeriodIsNotProvided: true };
      }
      if (newPeriod === initialPeriod) {
        return { newPeriodIsEqualToInitialPeriod: true };
      }
      return null;
    };
  }
}
